


































































import { Vue, Component } from "vue-property-decorator";
import path from "path";
import { deepClone } from "@/utils";
import { asyncRoutes } from "@/router";
import i18n from "@/lang";
import { getRoles, deleteRole, updateRole } from "@/api/permission";
import { RouteConfig } from "vue-router";
import {
  RolePermissions,
  PermissionType,
  Permission,
  ActionType,
  ResCode
} from "@/api/baseDefine";
import { ElTree, TreeData } from "element-ui/types/tree";
import { UserModule } from "@/store/modules/user";

interface RouteItem {
  path: string;
  title: string;
  children?: RouteItem[];
}

const defaultRole: RolePermissions = {
  key: "",
  name: "",
  desc: "",
  permissions: []
};
// 这里做的是前端的权限
@Component
export default class FrontRole extends Vue {
  public get routesData() {
    return this.routes;
  }
  private role = Object.assign({}, defaultRole);
  private routes: RouteItem[] = [];
  private rolesList: RolePermissions[] = [];
  private dialogVisible = false;
  private dialogType = "new";
  private checkStrictly = false;
  private defaultProps = {
    children: "children",
    label: "title"
  };

  // 快速读取路由的名字
  private mapNameRout: Map<string, string> = new Map();

  public async getRoutes() {
    // 前端权限其实就是动态路由表里面的内容
    this.mapNameRout.clear();
    const routes = this.generateRoutes(asyncRoutes);
    this.routes = this.i18n(routes);
  }
  public async getRoles() {
    const res = await getRoles();
    console.log(res);
    this.rolesList = res.data.rolelist.frontPermissions;
  }
  public i18n(routes: RouteItem[]) {
    const app = routes.map(route => {
      route.title = i18n.t(`route.${route.title}`) as string;
      if (route.children) {
        route.children = this.i18n(route.children);
      }
      return route;
    });
    return app;
  }
  // 把路由列表转换为权限树状结构
  public generateRoutes(routes: RouteConfig[], basePath = "/"): RouteItem[] {
    const res: RouteItem[] = [];

    for (let route of routes) {
      const onlyOneShowingChild = this.onlyOneShowingChild(
        route.children,
        route
      );
      // alwaysShow 移动到meta里面去
      if (route.children && onlyOneShowingChild && !route.meta.alwaysShow) {
        route = onlyOneShowingChild;
      }
      const data: RouteItem = {
        path: path.resolve(basePath, route.path),
        title: route.meta && route.meta.title
      };
      this.mapNameRout.set(data.path, data.title);
      // recursive child routes
      if (route.children) {
        data.children = this.generateRoutes(route.children, data.path);
      }
      res.push(data);
    }
    return res;
  }

  // 展开生成路由的数组，用于check控件的选中状态，以path为key
  public generateArr(prmissionsList: RolePermissions) {
    const data: string[] = [];
    if (prmissionsList.key === "group_admin_root") {
      // root用户所有权限都有
      return Array.from(this.mapNameRout.keys());
    }
    // 其他用户根据服务器返回读取
    prmissionsList.permissions.forEach(route => {
      data.push(route.path);
    });
    return data;
  }
  public handleAddRole() {
    this.role = Object.assign({}, defaultRole);
    if (this.$refs.tree) {
      (this.$refs.tree as ElTree).setCheckedKeys([]);
    }
    this.dialogType = "new";
    this.dialogVisible = true;
  }
  public handleEdit(scope) {
    this.dialogType = "edit";
    this.dialogVisible = true;
    this.checkStrictly = true;
    this.role = deepClone(scope.row) as RolePermissions;
    this.$nextTick(() => {
      // const routes = this.generateRoutes(this.role.routes);
      (this.$refs.tree as ElTree).setCheckedKeys(this.generateArr(this.role));
      // set checked state of a node not affects its father and child nodes
      // this.checkStrictly = false;
    });
  }
  public handleDelete({ $index, row }) {
    this.$confirm("Confirm to remove the role?", "Warning", {
      confirmButtonText: "Confirm",
      cancelButtonText: "Cancel",
      type: "warning"
    })
      .then(async () => {
        const res = await deleteRole({
          premissionType: PermissionType.FRONT,
          roleKey: row.key
        });
        if (res.code === ResCode.SUCCESS) {
          this.rolesList.splice($index, 1);
          this.$message({
            type: "success",
            message: "Delete succed!"
          });
        }
      })
      .catch(err => {
        console.error(err);
      });
  }

  // 选中的权限
  public generatePremissionFromTree(checkedKeys: TreeData[]): Permission[] {
    let res: Permission[] = [];

    for (const item of checkedKeys) {
      const routePath = (item as any).path;
      const data: Permission = {
        path: routePath,
        action: ActionType.ANY // 客户端权限只有ANY,此字段意义不大
      };
      res.push(data);
      // recursive child routes
      if (item.children) {
        const temp = this.generatePremissionFromTree(item.children);
        if (temp.length > 0) {
          res = [...res, ...temp];
        }
      }
    }
    return res;
  }
  public async confirmRole() {
    const isEdit = this.dialogType === "edit";

    const checkedNodes = (this.$refs.tree as ElTree).getCheckedNodes();
    this.role.permissions = this.generatePremissionFromTree(checkedNodes);

    // 不管是创建还是更新，调用同一个接口
    const res = await updateRole({
      premissionType: PermissionType.FRONT,
      roleItem: this.role
    });
    if (res.code !== ResCode.SUCCESS) {
      return;
    }
    let isNew = true;
    for (let index = 0; index < this.rolesList.length; index++) {
      if (this.rolesList[index].key === this.role.key) {
        this.rolesList.splice(index, 1, Object.assign({}, this.role));
        isNew = false;
        break;
      }
    }

    if (isNew) {
      this.rolesList.push(this.role);
    }
    const { desc, key, name } = this.role;
    this.dialogVisible = false;
    this.$notify({
      title: "Success",
      dangerouslyUseHTMLString: true,
      message: `
            <div>Role Key: ${key}</div>
            <div>Role Nmae: ${name}</div>
            <div>Description: ${desc}</div>
          `,
      type: "success"
    });
  }
  // reference: src/view/layout/components/Sidebar/SidebarItem.vue
  public onlyOneShowingChild(
    children: RouteConfig[] = [],
    parent
  ): RouteConfig | undefined {
    let onlyOneChild: RouteConfig;
    const showingChildren = children.filter(item => !item.meta.hidden);

    // When there is only one child route, the child route is displayed by default
    if (showingChildren.length === 1) {
      onlyOneChild = showingChildren[0];
      onlyOneChild.path = path.resolve(parent.path, onlyOneChild.path);
      return onlyOneChild;
    }

    // Show parent if there are no child route to display
    if (showingChildren.length === 0) {
      onlyOneChild = { ...parent, path: "", noShowingChildren: true };
      return onlyOneChild;
    }

    return undefined;
  }

  private created() {
    // Mock: get all routes and roles list from server
    this.getRoutes();
    this.getRoles();
  }
}
